import { Injectable } from '@angular/core'; 
import { ApiService } from '../../../services/api.service';

@Injectable()
export class PronunciationService {
 

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<Pronunciation[]> {

    const p = new Promise<Pronunciation[]>((resolve, reject) => {
 
      this.apiSvc.get("api/pronunciation/", null).subscribe(
        (data: Pronunciation[]) => {
          console.log(data); 

          this.ProcessResults(data);
          
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;
}

private  ProcessResults(items: any[]) {

 
  items.forEach(item => {
  
    var availableSearchTerms: string[] = [];
    // Set search terms for angular
    availableSearchTerms.push(item.Text); 
    availableSearchTerms.push(item.PronunciationHtml); 
    
    item.AvailableSearchTerms = availableSearchTerms;

  });
}

public save(entity: Pronunciation): Promise<Pronunciation> {
  
    const p = new Promise<Pronunciation>((resolve, reject) => {
  
      console.log("Saving Pronunciation", entity);

      this.apiSvc.post("api/pronunciation/save", entity).subscribe(
        (data: Pronunciation) => { 
          console.log(data);  
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          reject(err); 
        }
      );

    });

    return p;  
  } 

  public delete(entity: Pronunciation): Promise<void> {
  
    const p = new Promise<void>((resolve, reject) => {
  
      console.log("delete Pronunciation", entity);

      this.apiSvc.post("api/pronunciation/delete", entity).subscribe(
        (data: Pronunciation) => { 
          console.log(data);   
          resolve();
        },
        (err) => {
          console.log("error", err);
          reject(err); 
        }
      );

    });

    return p;  
  }  
  
}


export class Pronunciation {
    public Id :string;
    public Name: string;
    public PronunciationHtml : string;
    public IsActive: boolean;
  }